import React, { useEffect, useState } from "react";
import "./Navbar.css";
import Logo from "./Logo";
import { Link, animateScroll as scroll } from "react-scroll";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => setIsOpen((v) => !v);
  const closeMenu = () => setIsOpen(false);

  // Slight shadow / compact padding once user scrolls past hero start
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Home → scroll all the way to the very top (above the TopBar)
  const scrollToTop = () => {
    scroll.scrollToTop({ duration: 500, smooth: true });
    closeMenu();
  };

  // Other sections (not Home — that's handled separately)
  const navLinks = [
    { to: "about", label: "About Us" },
    { to: "services", label: "Services" },
    { to: "contact", label: "Contact Us" },
  ];

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={scrollToTop}>
          <Logo height={42} />
        </div>

        <div
          className="hamburger"
          onClick={toggleMenu}
          role="button"
          aria-label="Toggle menu"
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        <nav className={`navbar-links ${isOpen ? "open" : ""}`}>
          {/* Home is a special link that scrolls to the absolute top */}
          <a
            className="nav-home-link"
            onClick={scrollToTop}
            style={{ cursor: "pointer" }}
          >
            Home
          </a>

          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              smooth={true}
              duration={500}
              spy={true}
              activeClass="active"
              onClick={closeMenu}
              offset={-70}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;